import { render, staticRenderFns } from "./PromoHistory.vue?vue&type=template&id=7f9d2862"
import script from "./PromoHistory.vue?vue&type=script&lang=ts"
export * from "./PromoHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports